import Modal from '../index';

import baseTemplate from './index.html';
import header from '../partials/header.html';
import footer from '../partials/footer.html';

const template = header + baseTemplate + footer;
const source = 'https://www.youtube.com/embed/62GUa_XUosE?modestbranding=1&showinfo=1&rel=0';

export default Modal.extend({

  name: 'VideoModal',

  template,

  data: () => ({
    showCloseBtn: false,
    classModifier: 'modal--stretch modal--bg-black',
  }),

  methods: {
    onHide() {
      this.$refs.youtubeIframe.src = '';
    },
    onShow() {
      this.$refs.youtubeIframe.src = `${source}&autoplay=1`;
    },
  },
});



// WEBPACK FOOTER //
// ./src/js/components/modals/video/index.js